import { useAuth } from '@/hooks/useAuth';
import type { CustomUser } from '@/lib/customAuth';

export interface Profile {
  id: string;
  nickname: string;
  phone: string | null;
  avatar_url: string | null;
  level: string;
  performance: number;
  points: number;
  balance: number;
  referrer_id: string | null;
  status: string;
  created_at: string;
}

interface UseProfileResult {
  profile: Profile | null;
  loading: boolean;
  refetch: () => void;
}

// 把 CustomUser 映射成 Profile 结构，保持其他页面兼容
function toProfile(user: CustomUser): Profile {
  return {
    id: user.id,
    nickname: user.nickname,
    phone: user.phone,
    avatar_url: user.avatar_url,
    level: user.level,
    performance: user.performance ?? 0,
    points: user.points,
    balance: user.balance,
    referrer_id: null,
    status: user.status,
    created_at: user.created_at,
  };
}

export const useProfile = (): UseProfileResult => {
  const { user, loading, refresh } = useAuth();

  return {
    profile: user ? toProfile(user) : null,
    loading,
    refetch: refresh,
  };
};
